import React from 'react'
import { Link } from 'react-router-dom'
import { SEOHead } from '../components/ui/SEOHead'
import { TerminalWindow } from '../components/terminal/TerminalWindow'

export const SubscribeUnsubscribedPage: React.FC = () => (
  <>
    <SEOHead title="Unsubscribed" />
    <TerminalWindow title="unsubscribe.sh">
      <div
        style={{
          fontFamily: "'JetBrains Mono', 'Courier New', monospace",
          fontSize: '0.9rem',
          display: 'flex',
          flexDirection: 'column',
          gap: '12px',
        }}
      >
        <div style={{ color: 'var(--accent-amber)' }}>
          ✓ You&apos;ve been unsubscribed.
        </div>
        <div style={{ color: 'var(--text-secondary)' }}>
          You won&apos;t receive any more emails from CodeToByte.
        </div>
        <Link to="/" style={{ color: 'var(--accent-blue)', fontSize: '0.85rem' }}>
          [← back to home]
        </Link>
      </div>
    </TerminalWindow>
  </>
)
